import React from 'react';
import { RouterProvider } from '@/components/router';
import { AuthProvider, AuthNavigator } from '@/features/auth/hooks/use-auth';

interface AppProvidersProps {
  routes: Array<{
    path: string;
    component: React.ComponentType<any>;
    title?: string;
    description?: string;
  }>;
  children: React.ReactNode;
}

export function AppProviders({ routes, children }: AppProvidersProps) {
  return (
    <RouterProvider routes={routes}>
      <AuthProvider>
        <AuthNavigator />
        {children}
      </AuthProvider>
    </RouterProvider>
  );
}